
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5df6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5df6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("40Z8U", function(module, exports) {
$parcel$export(module.exports, "PixelButton", function () { return (parcelRequire("iN9TH")).PixelButton; });
$parcel$export(module.exports, "StatefulLoadingContainer", function () { return (parcelRequire("4JK8w")).StatefulLoadingContainer; });
// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Export custom web components.
 * @author James Reid
 */ // @ts-check
// @@no-imports
// @@no-body
// @@exports
parcelRequire("iN9TH");
parcelRequire("4JK8w");

});
parcelRegister("iN9TH", function(module, exports) {

$parcel$export(module.exports, "PixelButton", function () { return $dae47b0180d0f9dd$export$2e64f27de16040b1; });
// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Implement pixel button component.
 * @author James Reid
 */ // @ts-check
// @@imports-dependencies

var $702Nz = parcelRequire("702Nz");
// @@body
class $dae47b0180d0f9dd$export$2e64f27de16040b1 extends HTMLButtonElement {
    #text;
    #icon;
    #stroke;
    #height;
    /**
   * @param {string} text
   * @param {object} [obj]
   * @param {import("lucide").IconNode} [obj.icon]
   * @param {string} [obj.stroke]
   * @param {string} [obj.height]
   */ constructor(text, { icon: icon, stroke: stroke = "#0d2b45", height: height = "1em" } = {}){
        super();
        this.#text = text;
        this.#icon = icon;
        this.#stroke = stroke;
        this.#height = height;
    }
    connectedCallback() {
        const buttonText = document.createElement("p");
        buttonText.innerText = this.#text;
        const innerContainer = document.createElement("div");
        innerContainer.appendChild(buttonText);
        this.appendChild(innerContainer);
        this.classList.add("pixel-button");
        if (this.#icon) {
            const icon = (0, $702Nz.default)(this.#icon);
            icon.setAttribute("stroke", this.#stroke);
            icon.setAttribute("height", this.#height);
            icon.classList.add("my-icon-class");
            innerContainer.appendChild(icon);
        }
    }
}

});
parcelRegister("702Nz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $518ab436b847042c$export$2e2bcd8739ae039; });
/**
 * @license lucide v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $518ab436b847042c$var$createElement = (tag, attrs, children = [])=>{
    const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
    Object.keys(attrs).forEach((name)=>{
        element.setAttribute(name, String(attrs[name]));
    });
    if (children.length) children.forEach((child)=>{
        const childElement = $518ab436b847042c$var$createElement(...child);
        element.appendChild(childElement);
    });
    return element;
};
var $518ab436b847042c$export$2e2bcd8739ae039 = ([tag, attrs, children])=>$518ab436b847042c$var$createElement(tag, attrs, children);

});


parcelRegister("4JK8w", function(module, exports) {

$parcel$export(module.exports, "StatefulLoadingContainer", function () { return $372f2724b887db8c$export$eba58f2af78a5ad3; });
// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Implement basic stateful loading container web component.
 * @author James Reid
 */ // @ts-check
// @@no-imports
// @@body
class $372f2724b887db8c$export$eba58f2af78a5ad3 extends HTMLElement {
    #loading = this.dataset.loading === "false" ? false : true;
    #animation = {
        keyframes: [
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ],
        options: {
            easing: "ease-out",
            duration: 300
        },
        reverse: {
            direction: /** @type {PlaybackDirection} */ "reverse"
        }
    };
    /**
   * @param {any} [state]
   */ constructor(state = {}){
        super();
        this.state = state;
    }
    connectedCallback() {
        if (!this.dataset.loading?.match(/^true$|^false$/)) this.dataset.loading = true.toString();
        const loadingContainer = document.createElement("div");
        loadingContainer.classList.add("loading", "loading-container");
        const loadingText = document.createElement("p");
        loadingText.innerText = this.dataset.text || "Loading...";
        const loadingBar = document.createElement("div");
        loadingBar.classList.add("pixel-container", "loading-bar");
        const loadingBounce = document.createElement("div");
        loadingBounce.classList.add("pixel-container", "loading-bounce");
        loadingBar.appendChild(loadingBounce);
        loadingContainer.append(loadingText, loadingBar);
        const contentContainer = document.createElement("div");
        contentContainer.classList.add("content");
        this.classList.add("stateful-loading-container");
        this.append(loadingContainer, contentContainer);
    }
    /**
   *
   * @param {HTMLElement} newContent
   */ load(newContent) {
        return new Promise((resolve)=>{
            const { keyframes: keyframes, options: options, reverse: reverse } = this.#animation;
            const replaceContent = ()=>{
                this.contentContainer.replaceWith(newContent);
                this.contentContainer.animate(keyframes, {
                    ...options,
                    ...reverse
                }).addEventListener("finish", ()=>{
                    resolve({});
                });
            };
            if (this.loading) this.loadingContainer.animate(keyframes, options).addEventListener("finish", ()=>{
                this.loading = false;
                replaceContent();
            });
            else this.contentContainer.animate(keyframes, options).addEventListener("finish", replaceContent);
        });
    }
    unload() {
        return new Promise((resolve)=>{
            if (this.loading) resolve({});
            const { keyframes: keyframes, options: options, reverse: reverse } = this.#animation;
            this.contentContainer.animate(keyframes, options).addEventListener("finish", ()=>{
                this.loading = true;
                this.loadingContainer.animate(keyframes, {
                    ...options,
                    ...reverse
                }).addEventListener("finish", ()=>{
                    resolve({});
                });
            });
        });
    }
    get loading() {
        return this.#loading;
    }
    set loading(bool) {
        this.dataset.loading = bool.toString();
        this.#loading = bool;
    }
    get loadingContainer() {
        return this.getElementsByClassName("loading")[0];
    }
    get contentContainer() {
        return this.getElementsByClassName("content")[0];
    }
    static contentContainer() {
        const container = document.createElement("div");
        container.classList.add("content");
        return container;
    }
}

});


parcelRegister("hyrY4", function(module, exports) {

$parcel$export(module.exports, "runSelector", function () { return $cc7b4e76e8c80285$export$5f384e801479b4fc; });
// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Run selector page.
 * @author James Reid
 */ // @ts-check
// @@imports-package
parcelRequire("40Z8U");
var $iN9TH = parcelRequire("iN9TH");
var $4JK8w = parcelRequire("4JK8w");

var $8b8DC = parcelRequire("8b8DC");
// @@body
const { puzzleSelected: $cc7b4e76e8c80285$var$puzzleSelected } = (0, $8b8DC.IMPOSTORI_EVENTS);
/**
 * @param {StatefulLoadingContainer} root
 */ const $cc7b4e76e8c80285$export$5f384e801479b4fc = (root)=>{
    const event = new Event($cc7b4e76e8c80285$var$puzzleSelected);
    const { dailyPuzzles: dailyPuzzles } = root.state;
    if (dailyPuzzles.url) return root.dispatchEvent(event);
    delete dailyPuzzles.url;
    const container = (0, $4JK8w.StatefulLoadingContainer).contentContainer();
    for(const key in dailyPuzzles){
        const button = new (0, $iN9TH.PixelButton)(key.toUpperCase());
        button.addEventListener("click", ()=>{
            history.replaceState({
                page: "home"
            }, "");
            history.pushState({}, "");
            root.state.selectedPuzzle = dailyPuzzles[key][0];
            root.dispatchEvent(event);
        });
        container.appendChild(button);
    }
    root.load(container);
};

});
parcelRegister("8b8DC", function(module, exports) {

$parcel$export(module.exports, "IMPOSTORI_EVENTS", function () { return $5f460d24b913243f$export$10ec88fed98ffe9f; });
// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Global custom event strings for impostori game events.
 * @author James Reid
 */ // @ts-check
// @@no-imports
// @@body
const $5f460d24b913243f$export$10ec88fed98ffe9f = {
    resourceLoaded: "impostori-resource-loaded",
    puzzleSelected: "impostori-puzzle-selected",
    puzzleVerified: "impostori-puzzle-verified",
    tutorialComplete: "impostori-tutorial-complete",
    selectedCellUpdated: "impostori-selected-cell-updated"
};

});


// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Run Impostori SPA.
 * @author James Reid
 */ // @ts-check
// @@imports-dependencies
/*! (c) Andrea Giammarchi @webreflection ISC */ (function() {
    "use strict";
    var attributesObserver = function(whenDefined, MutationObserver1) {
        var attributeChanged = function attributeChanged(records) {
            for(var i = 0, length = records.length; i < length; i++)dispatch(records[i]);
        };
        var dispatch = function dispatch(_ref) {
            var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue;
            target.attributeChangedCallback(attributeName, oldValue, target.getAttribute(attributeName));
        };
        return function(target, is) {
            var attributeFilter = target.constructor.observedAttributes;
            if (attributeFilter) whenDefined(is).then(function() {
                new MutationObserver1(attributeChanged).observe(target, {
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: attributeFilter
                });
                for(var i = 0, length = attributeFilter.length; i < length; i++)if (target.hasAttribute(attributeFilter[i])) dispatch({
                    target: target,
                    attributeName: attributeFilter[i],
                    oldValue: null
                });
            });
            return target;
        };
    };
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function() {};
                return {
                    s: F,
                    n: function() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function() {
                it = it.call(o);
            },
            n: function() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function(e) {
                didErr = true;
                err = e;
            },
            f: function() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    /*! (c) Andrea Giammarchi - ISC */ var TRUE = true, FALSE = false, QSA$1 = "querySelectorAll";
    /**
   * Start observing a generic document or root element.
   * @param {(node:Element, connected:boolean) => void} callback triggered per each dis/connected element
   * @param {Document|Element} [root=document] by default, the global document to observe
   * @param {Function} [MO=MutationObserver] by default, the global MutationObserver
   * @param {string[]} [query=['*']] the selectors to use within nodes
   * @returns {MutationObserver}
   */ var notify = function notify(callback) {
        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
        var MO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MutationObserver;
        var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [
            "*"
        ];
        var loop = function loop(nodes, selectors, added, removed, connected, pass) {
            var _iterator = _createForOfIteratorHelper(nodes), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var node = _step.value;
                    if (pass || QSA$1 in node) {
                        if (connected) {
                            if (!added.has(node)) {
                                added.add(node);
                                removed["delete"](node);
                                callback(node, connected);
                            }
                        } else if (!removed.has(node)) {
                            removed.add(node);
                            added["delete"](node);
                            callback(node, connected);
                        }
                        if (!pass) loop(node[QSA$1](selectors), selectors, added, removed, connected, TRUE);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        };
        var mo = new MO(function(records) {
            if (query.length) {
                var selectors = query.join(",");
                var added = new Set(), removed = new Set();
                var _iterator2 = _createForOfIteratorHelper(records), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = _step2.value, addedNodes = _step2$value.addedNodes, removedNodes = _step2$value.removedNodes;
                        loop(removedNodes, selectors, added, removed, FALSE, FALSE);
                        loop(addedNodes, selectors, added, removed, TRUE, FALSE);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
        });
        var observe = mo.observe;
        (mo.observe = function(node) {
            return observe.call(mo, node, {
                subtree: TRUE,
                childList: TRUE
            });
        })(root);
        return mo;
    };
    var QSA = "querySelectorAll";
    var _self$1 = self, document$2 = _self$1.document, Element$1 = _self$1.Element, MutationObserver$2 = _self$1.MutationObserver, Set$2 = _self$1.Set, WeakMap$1 = _self$1.WeakMap;
    var elements = function elements(element) {
        return QSA in element;
    };
    var filter = [].filter;
    var qsaObserver = function(options) {
        var live = new WeakMap$1();
        var drop = function drop(elements) {
            for(var i = 0, length = elements.length; i < length; i++)live["delete"](elements[i]);
        };
        var flush = function flush() {
            var records = observer.takeRecords();
            for(var i = 0, length = records.length; i < length; i++){
                parse(filter.call(records[i].removedNodes, elements), false);
                parse(filter.call(records[i].addedNodes, elements), true);
            }
        };
        var matches = function matches(element) {
            return element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
        };
        var notifier = function notifier(element, connected) {
            var selectors;
            if (connected) {
                for(var q, m = matches(element), i = 0, length = query.length; i < length; i++)if (m.call(element, q = query[i])) {
                    if (!live.has(element)) live.set(element, new Set$2());
                    selectors = live.get(element);
                    if (!selectors.has(q)) {
                        selectors.add(q);
                        options.handle(element, connected, q);
                    }
                }
            } else if (live.has(element)) {
                selectors = live.get(element);
                live["delete"](element);
                selectors.forEach(function(q) {
                    options.handle(element, connected, q);
                });
            }
        };
        var parse = function parse(elements) {
            var connected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            for(var i = 0, length = elements.length; i < length; i++)notifier(elements[i], connected);
        };
        var query = options.query;
        var root = options.root || document$2;
        var observer = notify(notifier, root, MutationObserver$2, query);
        var attachShadow = Element$1.prototype.attachShadow;
        if (attachShadow) Element$1.prototype.attachShadow = function(init) {
            var shadowRoot = attachShadow.call(this, init);
            observer.observe(shadowRoot);
            return shadowRoot;
        };
        if (query.length) parse(root[QSA](query));
        return {
            drop: drop,
            flush: flush,
            observer: observer,
            parse: parse
        };
    };
    var _self = self, document$1 = _self.document, Map = _self.Map, MutationObserver$1 = _self.MutationObserver, Object$1 = _self.Object, Set$1 = _self.Set, WeakMap = _self.WeakMap, Element = _self.Element, HTMLElement = _self.HTMLElement, Node = _self.Node, Error = _self.Error, TypeError$1 = _self.TypeError, Reflect = _self.Reflect;
    var defineProperty = Object$1.defineProperty, keys = Object$1.keys, getOwnPropertyNames = Object$1.getOwnPropertyNames, setPrototypeOf = Object$1.setPrototypeOf;
    var legacy = !self.customElements;
    var expando = function expando(element) {
        var key = keys(element);
        var value = [];
        var ignore = new Set$1();
        var length = key.length;
        for(var i = 0; i < length; i++){
            value[i] = element[key[i]];
            try {
                delete element[key[i]];
            } catch (SafariTP) {
                ignore.add(i);
            }
        }
        return function() {
            for(var _i = 0; _i < length; _i++)ignore.has(_i) || (element[key[_i]] = value[_i]);
        };
    };
    if (legacy) {
        var HTMLBuiltIn = function HTMLBuiltIn() {
            var constructor = this.constructor;
            if (!classes.has(constructor)) throw new TypeError$1("Illegal constructor");
            var is = classes.get(constructor);
            if (override) return augment(override, is);
            var element = createElement.call(document$1, is);
            return augment(setPrototypeOf(element, constructor.prototype), is);
        };
        var createElement = document$1.createElement;
        var classes = new Map();
        var defined = new Map();
        var prototypes = new Map();
        var registry = new Map();
        var query = [];
        var handle = function handle(element, connected, selector) {
            var proto = prototypes.get(selector);
            if (connected && !proto.isPrototypeOf(element)) {
                var redefine = expando(element);
                override = setPrototypeOf(element, proto);
                try {
                    new proto.constructor();
                } finally{
                    override = null;
                    redefine();
                }
            }
            var method = "".concat(connected ? "" : "dis", "connectedCallback");
            if (method in proto) element[method]();
        };
        var _qsaObserver = qsaObserver({
            query: query,
            handle: handle
        }), parse = _qsaObserver.parse;
        var override = null;
        var whenDefined = function whenDefined(name) {
            if (!defined.has(name)) {
                var _, $ = new Promise(function($) {
                    _ = $;
                });
                defined.set(name, {
                    $: $,
                    _: _
                });
            }
            return defined.get(name).$;
        };
        var augment = attributesObserver(whenDefined, MutationObserver$1);
        self.customElements = {
            define: function define(is, Class) {
                if (registry.has(is)) throw new Error('the name "'.concat(is, '" has already been used with this registry'));
                classes.set(Class, is);
                prototypes.set(is, Class.prototype);
                registry.set(is, Class);
                query.push(is);
                whenDefined(is).then(function() {
                    parse(document$1.querySelectorAll(is));
                });
                defined.get(is)._(Class);
            },
            get: function get(is) {
                return registry.get(is);
            },
            whenDefined: whenDefined
        };
        defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, "constructor", {
            value: HTMLBuiltIn
        });
        self.HTMLElement = HTMLBuiltIn;
        document$1.createElement = function(name, options) {
            var is = options && options.is;
            var Class = is ? registry.get(is) : registry.get(name);
            return Class ? new Class() : createElement.call(document$1, name);
        };
        // in case ShadowDOM is used through a polyfill, to avoid issues
        // with builtin extends within shadow roots
        if (!("isConnected" in Node.prototype)) defineProperty(Node.prototype, "isConnected", {
            configurable: true,
            get: function get() {
                return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
            }
        });
    } else {
        legacy = !self.customElements.get("extends-br");
        if (legacy) try {
            var BR = function BR() {
                return self.Reflect.construct(HTMLBRElement, [], BR);
            };
            BR.prototype = HTMLLIElement.prototype;
            var is = "extends-br";
            self.customElements.define("extends-br", BR, {
                "extends": "br"
            });
            legacy = document$1.createElement("br", {
                is: is
            }).outerHTML.indexOf(is) < 0;
            var _self$customElements = self.customElements, get = _self$customElements.get, _whenDefined = _self$customElements.whenDefined;
            self.customElements.whenDefined = function(is) {
                var _this = this;
                return _whenDefined.call(this, is).then(function(Class) {
                    return Class || get.call(_this, is);
                });
            };
        } catch (o_O) {}
    }
    if (legacy) {
        var _parseShadow = function _parseShadow(element) {
            var root = shadowRoots.get(element);
            _parse(root.querySelectorAll(this), element.isConnected);
        };
        var customElements = self.customElements;
        var _createElement = document$1.createElement;
        var define = customElements.define, _get = customElements.get, upgrade = customElements.upgrade;
        var _ref = Reflect || {
            construct: function construct(HTMLElement) {
                return HTMLElement.call(this);
            }
        }, construct = _ref.construct;
        var shadowRoots = new WeakMap();
        var shadows = new Set$1();
        var _classes = new Map();
        var _defined = new Map();
        var _prototypes = new Map();
        var _registry = new Map();
        var shadowed = [];
        var _query = [];
        var getCE = function getCE(is) {
            return _registry.get(is) || _get.call(customElements, is);
        };
        var _handle = function _handle(element, connected, selector) {
            var proto = _prototypes.get(selector);
            if (connected && !proto.isPrototypeOf(element)) {
                var redefine = expando(element);
                _override = setPrototypeOf(element, proto);
                try {
                    new proto.constructor();
                } finally{
                    _override = null;
                    redefine();
                }
            }
            var method = "".concat(connected ? "" : "dis", "connectedCallback");
            if (method in proto) element[method]();
        };
        var _qsaObserver2 = qsaObserver({
            query: _query,
            handle: _handle
        }), _parse = _qsaObserver2.parse;
        var _qsaObserver3 = qsaObserver({
            query: shadowed,
            handle: function handle(element, connected) {
                if (shadowRoots.has(element)) {
                    if (connected) shadows.add(element);
                    else shadows["delete"](element);
                    if (_query.length) _parseShadow.call(_query, element);
                }
            }
        }), parseShadowed = _qsaObserver3.parse;
        // qsaObserver also patches attachShadow
        // be sure this runs *after* that
        var attachShadow = Element.prototype.attachShadow;
        if (attachShadow) Element.prototype.attachShadow = function(init) {
            var root = attachShadow.call(this, init);
            shadowRoots.set(this, root);
            return root;
        };
        var _whenDefined2 = function _whenDefined2(name) {
            if (!_defined.has(name)) {
                var _, $ = new Promise(function($) {
                    _ = $;
                });
                _defined.set(name, {
                    $: $,
                    _: _
                });
            }
            return _defined.get(name).$;
        };
        var _augment = attributesObserver(_whenDefined2, MutationObserver$1);
        var _override = null;
        getOwnPropertyNames(self).filter(function(k) {
            return /^HTML.*Element$/.test(k);
        }).forEach(function(k) {
            var HTMLElement = self[k];
            function HTMLBuiltIn() {
                var constructor = this.constructor;
                if (!_classes.has(constructor)) throw new TypeError$1("Illegal constructor");
                var _classes$get = _classes.get(constructor), is = _classes$get.is, tag = _classes$get.tag;
                if (is) {
                    if (_override) return _augment(_override, is);
                    var element = _createElement.call(document$1, tag);
                    element.setAttribute("is", is);
                    return _augment(setPrototypeOf(element, constructor.prototype), is);
                } else return construct.call(this, HTMLElement, [], constructor);
            }
            defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, "constructor", {
                value: HTMLBuiltIn
            });
            defineProperty(self, k, {
                value: HTMLBuiltIn
            });
        });
        document$1.createElement = function(name, options) {
            var is = options && options.is;
            if (is) {
                var Class = _registry.get(is);
                if (Class && _classes.get(Class).tag === name) return new Class();
            }
            var element = _createElement.call(document$1, name);
            if (is) element.setAttribute("is", is);
            return element;
        };
        customElements.get = getCE;
        customElements.whenDefined = _whenDefined2;
        customElements.upgrade = function(element) {
            var is = element.getAttribute("is");
            if (is) {
                var _constructor = _registry.get(is);
                if (_constructor) {
                    _augment(setPrototypeOf(element, _constructor.prototype), is);
                    // apparently unnecessary because this is handled by qsa observer
                    // if (element.isConnected && element.connectedCallback)
                    //   element.connectedCallback();
                    return;
                }
            }
            upgrade.call(customElements, element);
        };
        customElements.define = function(is, Class, options) {
            if (getCE(is)) throw new Error("'".concat(is, "' has already been defined as a custom element"));
            var selector;
            var tag = options && options["extends"];
            _classes.set(Class, tag ? {
                is: is,
                tag: tag
            } : {
                is: "",
                tag: is
            });
            if (tag) {
                selector = "".concat(tag, '[is="').concat(is, '"]');
                _prototypes.set(selector, Class.prototype);
                _registry.set(is, Class);
                _query.push(selector);
            } else {
                define.apply(customElements, arguments);
                shadowed.push(selector = is);
            }
            _whenDefined2(is).then(function() {
                if (tag) {
                    _parse(document$1.querySelectorAll(selector));
                    shadows.forEach(_parseShadow, [
                        selector
                    ]);
                } else parseShadowed(document$1.querySelectorAll(selector));
            });
            _defined.get(is)._(Class);
        };
    }
})();


// Copyright (c) 2024 James Reid. All rights reserved.
//
// This source code file is licensed under the terms of the MIT license, a copy
// of which may be found in the LICENSE.md file in the root of this repository.
//
// For a template copy of the license see one of the following 3rd party sites:
//      - <https://opensource.org/licenses/MIT>
//      - <https://choosealicense.com/licenses/mit>
//      - <https://spdx.org/licenses/MIT>
/**
 * @file Set body hoverable class for correctly rendering mobile buttons which
 *      have just been clicked.
 * @author James Reid
 */ // @ts-check
// @@no-imports
// @@body
const $3998dc0446f57e66$export$491979a7c8fb2d1c = ()=>{
    let isTouchActive = false;
    const updateHoverable = ()=>{
        isTouchActive ? document.body.classList.remove("hoverable") : document.body.classList.add("hoverable");
    };
    document.addEventListener("touchstart", ()=>{
        // Activate touch then update hoverable class.
        isTouchActive = true;
        updateHoverable();
    });
    document.addEventListener("mousemove", ()=>{
        // Update hoverable class *first* then disable touch in order to ignore
        // emulated mousemove events dispatched after touchstart or touchend
        // events.
        updateHoverable();
        isTouchActive = false;
    });
    updateHoverable();
};


parcelRequire("40Z8U");
var $iN9TH = parcelRequire("iN9TH");
var $4JK8w = parcelRequire("4JK8w");

var $hyrY4 = parcelRequire("hyrY4");
// @@body
/**
 * @todo Submit completed site for review to the following sites, youtube
 *      creators etc.:
 *      - [aliensrock](https://www.youtube.com/@Aliensrock)
 *      - [cracking the cryptic](https://www.youtube.com/@CrackingTheCryptic)
 *      - [reddit puzzles](https://www.reddit.com/r/puzzles/)
 * @todo Add completed puzzle site to itch.io.
 * @todo Add "test" and "commit"/"revert" buttons for testing a hypothesis about
 *      a candidate/cell.
 * @todo Add puzzle "reset" button.
 * @todo Add "go home" button to return to selector screen.
 * @todo Add timing feature to see how fast you can solve a puzzle.
 * @todo Add "share" button to share puzzle in current solve state.
 * @todo Add puzzle grade and rating to top nav.
 * @todo Add number of cells found/completed by type indicator.
 * @todo Add buttons to remove all candidates in a cell by type (also add to
 *      spritesheet to reflect type choice in shading of platform frame?).
 * @todo Refactor _Puzzle to _Impostori method and state naming etc.
 * @todo Add state to loading container with redact method etc.
 * @todo Fix cyclical object bug on Boutique proxy to object feature (add
 *      tracker to detect cyclical object and resolve them).
 * @todo Add multiple radii to pixel container borders (add "pixel-radius-x"
 *      class styles).
 * @todo Update unload method to return a promise, then only render next page
 *      after unload is done. Promisify load method too on container.
 * @todo Include separate scripts, one to render the loading container, then one
 *      which loads pixi and starts the spritesheet import etc.
 * @todo Add bookmark and undo features to allow users to test and rollback.
 * @todo Add zoom ability to grid portion of pixi container.
 * @todo Remove root from stateful loading container (just target the container
 *      instead in css etc.).
 * @todo Add root div to html to which nav and loading container are appended?
 * @todo Change popstate listener to directly execute a function passed in the
 *      history state object.
 * @todo Add data to resolve object on load/unload methods in loading container.
 * @todo Remove direct calls to re-render puzzle by relying on state events
 *      instead.
 * @todo Add type declaration for "complete" root state.
 * @todo Add checking on selected puzzle to see that it is a valid puzzle.
 * @todo Update "package" imports from impostori package to be "dependency"
 *      imports instead.
 * @todo Look into creating own, bespoke pixel icon set in aseprite or
 *      vectornator specifically for this game (after a brief search online).
 * @todo Move puzzle checking to separate file/folder.
 * @todo Move loaders, hoverable and events into state module folder.
 * @todo Consider changing IMPOSTORI_EVENTS export into individual const exports
 *      of each required event string.
 */ /**
 * Steps:
 * 1. Run scripts to setup page and define custom web components.
 * 2. Declare Boutique store:
 *      2.1 Load spritesheet async and add to store with redaction.
 *      2.2 Load daily puzzles async and add to store with redaction.
 * 3. Select encoded puzzle string:
 *      3.1 Check url parameters for existing puzzle string to use by default.
 *      3.2 Check local storage for incomplete local puzzle, and add this to
 *          "pick up where you left off" option for this device.
 *      3.3 Update store to indicate that url params and local storage have been
 *          checked, and selector can be rendered.
 *      3.4 On daily puzzles loaded *and* url parameters checked, render list of
 *          daily puzzles, and wait for user to choose, then update store.
 *      3.5 Update impostori and encodedImpostori strings in store.
 * 4. On spritesheet loaded *and* encoded puzzle string chosen, run tutorial:
 *      4.1 Check local storage for if tutorial completed, if so set store value
 *          for tutorial complete.
 *      4.2 Otherwise render tutorial slide based on current active slide in
 *          store (default 0). Re-render on store update.
 *      4.3 Add buttons for "skip" and "prev"/"next" which update store current
 *          slide as required.
 *      4.4 Tutorials should have an optional pixi container, and text split
 *          into paragraphs. Next button will display subsequent paragraphs
 *          until next slide with new pixi container.
 *      4.5 Pixi app should fill screen, and interface should be over-layed in
 *          an absolute positioned, full screen div
 * 5. On tutorial complete, run puzzle:
 *      5.1 Render grid and interface.
 *      5.2 Re-render grid on cell/candidate change, and check if grid complete.
 *      5.3 If grid complete, notify user.
 */ // Declare custom web components, and run miscellaneous setup functions.
customElements.define("pixel-button", (0, $iN9TH.PixelButton), {
    extends: "button"
});
customElements.define("stateful-loading-container", (0, $4JK8w.StatefulLoadingContainer));
(0, $3998dc0446f57e66$export$491979a7c8fb2d1c)();
const $265425cd80ebd0ad$var$nav = document.createElement("nav");
$265425cd80ebd0ad$var$nav.classList.add("pixel-container");
const $265425cd80ebd0ad$var$signIn = new (0, $iN9TH.PixelButton)("Sign In");
const $265425cd80ebd0ad$var$signUp = new (0, $iN9TH.PixelButton)("Sign Up");
$265425cd80ebd0ad$var$nav.append($265425cd80ebd0ad$var$signIn, $265425cd80ebd0ad$var$signUp);
const $265425cd80ebd0ad$var$root = new (0, $4JK8w.StatefulLoadingContainer)();
$265425cd80ebd0ad$var$root.id = "root";
$265425cd80ebd0ad$var$root.classList.add("pixel-container");
document.body.append($265425cd80ebd0ad$var$nav, $265425cd80ebd0ad$var$root);
window.addEventListener("popstate", (event)=>{
    if (event && event.state) {
        const { page: page } = event.state;
        switch(page){
            case "home":
                (0, $hyrY4.runSelector)($265425cd80ebd0ad$var$root);
                break;
            default:
                (0, $hyrY4.runSelector)($265425cd80ebd0ad$var$root);
        }
    }
}); // @@no-exports


//# sourceMappingURL=index.fd4a0e4e.js.map
